import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HistoryToggleOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"history_toggle_off"}/>
}
